import React from 'react';
import ReactSVG from 'react-svg';
import { DialogContent, DialogActions, Button } from '@material-ui/core';
import * as lib from '~/dependencies';
import { TrashIcon } from '~/assets/svgIcons';
import { DialogComponent } from './styles';

export default function ConfirmationBox({
  setOpenModal,
  openModal,
  handleAction,
}) {
  // HOOKS
  const { t } = lib.useTranslation();

  function confirmationBox(action) {
    setOpenModal(false);
    handleAction(action);
  }

  return (
    <DialogComponent
      onClose={() => setOpenModal(false)}
      open={openModal}
      className="modalBox">
      <DialogContent className="content">
        <ReactSVG src={TrashIcon} className="trash-icon" />
        <span>{t('components.confirmationBox.title')}</span>
      </DialogContent>
      <DialogActions className="actions">
        <Button onClick={() => confirmationBox(false)} color="primary">
          {t('components.confirmationBox.btnCancel')}
        </Button>
        <Button onClick={() => confirmationBox(true)} color="primary">
          {t('components.confirmationBox.btnConfirm')}
        </Button>
      </DialogActions>
    </DialogComponent>
  );
}

ConfirmationBox.defaultProps = {
  openModal: lib.PropTypes.bool,
};

ConfirmationBox.propTypes = {
  setOpenModal: lib.PropTypes.func.isRequired,
  handleAction: lib.PropTypes.func.isRequired,
  openModal: lib.PropTypes.bool,
};
